import { useState } from 'react';

export default function ShareVehicleModal({ vehicle, onUpdate, onClose, onToast }) {
  const [email, setEmail] = useState('');
  const [collaborators, setCollaborators] = useState(vehicle.collaborators || []);

  const label = `${vehicle.year} ${vehicle.make} ${vehicle.model}`;

  function handleInvite(e) {
    e.preventDefault();
    const trimmed = email.trim().toLowerCase();
    if (!trimmed || !trimmed.includes('@')) return;
    if (collaborators.some((c) => c.email === trimmed)) {
      onToast('Already a collaborator');
      return;
    }
    const updated = [...collaborators, { email: trimmed, addedAt: new Date().toISOString() }];
    setCollaborators(updated);
    onUpdate(vehicle.id, { collaborators: updated });
    setEmail('');
    onToast(`Invite sent to ${trimmed}`);
  }

  function handleRemove(emailToRemove) {
    const updated = collaborators.filter((c) => c.email !== emailToRemove);
    setCollaborators(updated);
    onUpdate(vehicle.id, { collaborators: updated });
  }

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.7)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 200,
        padding: 20,
      }}
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: 'var(--bg-card)',
          borderRadius: 'var(--radius-md)',
          padding: 24,
          width: '100%',
          maxWidth: 360,
          border: '1px solid var(--border)',
        }}
      >
        {/* Header */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
          <h2 style={{ fontSize: '1.125rem', fontWeight: 700 }}>Share Vehicle</h2>
          <button
            onClick={onClose}
            style={{
              width: 28,
              height: 28,
              borderRadius: '50%',
              background: 'var(--bg-elevated)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'var(--text-muted)',
              fontSize: '1rem',
            }}
          >
            x
          </button>
        </div>

        <p style={{ fontSize: '0.8125rem', color: 'var(--text-secondary)', marginBottom: 20, lineHeight: 1.4 }}>
          Share <strong>{label}</strong> with others. Collaborators can view and log maintenance for this vehicle.
        </p>

        {/* Add collaborator */}
        <form onSubmit={handleInvite} style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
          <input
            className="form-input"
            type="email"
            placeholder="email@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{ flex: 1 }}
          />
          <button
            type="submit"
            className="btn btn-primary"
            disabled={!email.trim()}
            style={{ width: 'auto', padding: '10px 16px', fontSize: '0.8125rem' }}
          >
            Invite
          </button>
        </form>

        {/* Collaborator list */}
        {collaborators.length > 0 ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {collaborators.map((collab) => (
              <div
                key={collab.email}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  padding: '8px 12px',
                  background: 'var(--bg-elevated)',
                  borderRadius: 'var(--radius-sm)',
                }}
              >
                <div style={{ minWidth: 0, flex: 1 }}>
                  <div style={{ fontSize: '0.8125rem', fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {collab.email}
                  </div>
                  <div style={{ fontSize: '0.6875rem', color: 'var(--text-muted)' }}>
                    Can view & log maintenance
                  </div>
                </div>
                <button
                  onClick={() => handleRemove(collab.email)}
                  style={{
                    fontSize: '0.75rem',
                    color: 'var(--danger)',
                    fontWeight: 600,
                    padding: '4px 8px',
                    flexShrink: 0,
                  }}
                >
                  Remove
                </button>
              </div>
            ))}
          </div>
        ) : (
          <p style={{ fontSize: '0.8125rem', color: 'var(--text-muted)', textAlign: 'center', padding: '12px 0' }}>
            No collaborators yet
          </p>
        )}

        {/* Close */}
        <button
          className="btn btn-secondary"
          onClick={onClose}
          style={{ marginTop: 16 }}
        >
          Done
        </button>
      </div>
    </div>
  );
}
